// Сургууль: хүсэлт илгээх — чөлөө хүсэх (эцэг эх: ирцэд шууд; сурагч өөрөө: хаусын багшид хүсэлт), өдөр өнжүүлэх ба санал хүсэлт (бага анги);
// 7 хоногийн хоолны цэс, хичээлийн жилийн календарь. Сурагч (roleId 4) — өөрийнх ("me"), эцэг эх — бүх хүүхэд (?c=).
import React, { useContext, useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Spin, message } from "antd";
import { FiCalendar, FiClock, FiMessageSquare, FiGrid, FiChevronRight, FiCreditCard, FiPlayCircle } from "react-icons/fi";
import PassionIcon from "components/PassionIcon";
import { AuthContext } from "contexts";
import dayjs from "dayjs";
import { instance } from "utils/axios";
import DaycareCard from "../Home/DaycareCard";
import { KidTabs, md, useKids } from "./shared";

const DAYN = ["Ням", "Даваа", "Мягмар", "Лхагва", "Пүрэв", "Баасан", "Бямба"];
const errText = (e) => e?.response?.data?.error || "Алдаа гарлаа";
const ACTIONS = [
  ["leave", "Чөлөө хүсэх", "Өвчтэй, гэр бүлийн шалтгаан", FiCalendar, "#5c1090"],
  ["daycare", "Өдөр өнжүүлэх хүсэлт", "Хичээлийн дараах цагаар", FiClock, "#0e7490"],
  ["feedback", "Санал хүсэлт илгээх", "Багш, удирдлагад", FiMessageSquare, "#7a5a00"],
];
const STATUS = { Өвчтэй: "Өвчтэй", Чөлөөтэй: "Чөлөөтэй" };
const Label = ({ children }) => <span className="block text-sm font-semibold mb-1.5">{children}</span>;
const input = "w-full h-11 rounded-[10px] border border-[#e5d8f5] bg-white px-3 text-[15px] focus:outline-none focus:border-primary";

function LeaveForm({ kid, d, reload }) {
  const today = dayjs().format("YYYY-MM-DD");
  const [f, setF] = useState({ from: today, to: today, reason: "sick", note: "" });
  const [busy, setBusy] = useState(false);
  const send = () => {
    setBusy(true);
    instance({ method: "post", url: `/student/school/${kid.id}/leave`, data: f, silent: true })
      .then((r) => { message.success(r.data.requested ? "Хүсэлт хаусын багшид илгээгдлээ" : `${r.data.days.length} өдрийн чөлөө бүртгэгдлээ`); setF({ ...f, note: "" }); reload(); })
      .catch((e) => message.error(errText(e))).finally(() => setBusy(false));
  };
  return (
    <div className="flex flex-wrap gap-5 items-stretch">
      <div className="flex-[1.6_1_380px] min-w-0 flex flex-col gap-4">
        <h3 className="m-0 text-lg font-bold">Чөлөө хүсэх</h3>
        <div className="grid grid-cols-2 gap-3">
          <label><Label>Эхлэх өдөр</Label><input type="date" className={input} value={f.from} min={dayjs().subtract(7, "day").format("YYYY-MM-DD")} onChange={(e) => setF({ ...f, from: e.target.value, to: e.target.value > f.to ? e.target.value : f.to })} /></label>
          <label><Label>Дуусах өдөр</Label><input type="date" className={input} value={f.to} min={f.from} onChange={(e) => setF({ ...f, to: e.target.value })} /></label>
        </div>
        <fieldset className="m-0 p-0 border-0">
          <Label>Шалтгаан</Label>
          <div className="flex flex-wrap gap-4">
            {Object.entries(d.reasons).map(([k, l]) => (
              <label key={k} className="inline-flex items-center gap-2 text-[15px] cursor-pointer">
                <input type="radio" name="reason" checked={f.reason === k} onChange={() => setF({ ...f, reason: k })} className="accent-[#5c1090] w-4 h-4" />{l}
              </label>
            ))}
          </div>
        </fieldset>
        <label><Label>Тайлбар</Label><textarea rows={3} className={`${input} h-auto py-2.5`} placeholder="Багшид мэдэгдэх зүйл байвал бичээрэй" value={f.note} onChange={(e) => setF({ ...f, note: e.target.value })} /></label>
        <div className="flex flex-wrap items-center gap-3">
          <button type="button" disabled={busy} onClick={send} className="h-11 px-6 rounded-[10px] bg-primary text-white font-bold disabled:opacity-60">Хүсэлт илгээх</button>
          {kid.id === "me" ? <span className="text-sm text-[#6e5e8a]">Хаусын багшид хүсэлт болж очно · багш ирцийг баталгаажуулна</span>
            : kid.elem && d.teacher ? <span className="text-sm text-[#6e5e8a]">Багш {d.teacher}-д очно · ирцэд шууд тэмдэглэгдэнэ</span>
              : <span className="text-sm text-[#6e5e8a]">Хаусын багшид очно · ирцэд шууд тэмдэглэгдэнэ</span>}
        </div>
      </div>
      <aside className="flex-[1_1_280px] min-w-0 rounded-2xl bg-[#faf7ff] border border-[#e5d8f5] p-4 md:p-5">
        <div className="text-sm font-bold mb-2">Өмнөх хүсэлтүүд</div>
        {!d.leaves.length ? <p className="m-0 text-sm text-[#6e5e8a]">Хүсэлт алга.</p> : d.leaves.map((l, i) => (
          <div key={i} className="flex items-start justify-between gap-2 py-2.5 border-t border-[#e9e2f5]">
            <span>
              <span className="block text-[15px] font-bold">{md(l.from)}{l.to !== l.from ? ` – ${md(l.to)}` : ""} · {STATUS[l.status] || l.status}</span>
              <span className="block text-xs text-[#6e5e8a]">{l.days} өдөр{l.note ? ` · ${l.note.replace(/^Эцэг эх: /, "")}` : ""}</span>
            </span>
            <span className="inline-flex items-center h-6 px-2.5 rounded-full bg-[#dcfce7] text-[#166534] text-xs font-bold whitespace-nowrap">Бүртгэгдсэн</span>
          </div>
        ))}
      </aside>
    </div>
  );
}

function FeedbackForm({ kid }) {
  const [f, setF] = useState({ to: "teacher", text: "" });
  const [busy, setBusy] = useState(false);
  const send = () => {
    setBusy(true);
    instance({ method: "post", url: `/student/elem/${kid.id}/feedback`, data: f, silent: true })
      .then(() => { message.success("Илгээлээ"); setF({ ...f, text: "" }); })
      .catch((e) => message.error(errText(e))).finally(() => setBusy(false));
  };
  return (
    <div className="flex flex-col gap-4 max-w-[720px]">
      <h3 className="m-0 text-lg font-bold">Санал хүсэлт илгээх</h3>
      <div className="flex flex-wrap gap-4">
        {[["teacher", "Багшид"], ["admin", "Удирдлагад"]].map(([k, l]) => (
          <label key={k} className="inline-flex items-center gap-2 text-[15px] cursor-pointer"><input type="radio" name="to" checked={f.to === k} onChange={() => setF({ ...f, to: k })} className="accent-[#5c1090] w-4 h-4" />{l}</label>
        ))}
      </div>
      <textarea rows={5} className={`${input} h-auto py-2.5`} placeholder="Санал, хүсэлт, асуултаа бичнэ үү" value={f.text} onChange={(e) => setF({ ...f, text: e.target.value })} />
      <button type="button" disabled={busy || f.text.trim().length < 3} onClick={send} className="self-start h-11 px-6 rounded-[10px] bg-primary text-white font-bold disabled:opacity-60">Илгээх</button>
    </div>
  );
}

// 7 хоногийн хоолны цэс — өнөөдрийг тодруулна
function Meals({ d }) {
  return (
    <section className="tj-card px-4 py-5 md:p-6 flex flex-col">
      <div className="flex flex-wrap items-end justify-between gap-2 mb-3">
        <div><h2 className="m-0 text-xl md:text-[22px] font-bold">7 хоногийн хоолны цэс</h2><div className="text-sm text-[#6e5e8a]">{md(d.weekStart)} – {md(d.weekEnd)}</div></div>
        <span className="text-[13px] text-[#6e5e8a]">Харшлын мэдээллээ багшид мэдэгдээрэй</span>
      </div>
      {!d.hasMeals ? <p className="m-0 text-sm text-[#6e5e8a]">Энэ 7 хоногийн цэс оруулаагүй байна.</p> : (
        <>
          <div className="hidden md:grid grid-cols-[110px_1fr_1fr] gap-3 px-3 pb-2 text-xs font-bold text-[#6e5e8a]"><span /><span>Өглөөний зууш</span><span>Өдрийн хоол</span></div>
          {d.meals.map((m) => {
            const today = m.date === d.today;
            return (
              <div key={m.date} className={`grid grid-cols-[90px_1fr] md:grid-cols-[110px_1fr_1fr] gap-x-3 gap-y-0.5 px-3 py-3 rounded-xl ${today ? "bg-[#f3eeff]" : "border-t border-[#efedf4] rounded-none"}`}>
                <span className="row-span-2 md:row-span-1"><span className={`block text-[15px] font-bold ${today ? "text-primary" : ""}`}>{DAYN[new Date(`${m.date}T00:00:00Z`).getUTCDay()]}</span><span className="text-xs text-[#6e5e8a]">{md(m.date)}</span></span>
                <span className="text-[15px] text-[#1c1c1c]">{m.breakfast || "—"}</span>
                <span className="text-[15px] font-semibold">{m.lunch || "—"}</span>
              </div>
            );
          })}
        </>
      )}
    </section>
  );
}

function Calendar({ d }) {
  return (
    <section className="tj-card px-4 py-5 md:p-6 flex flex-col gap-1">
      <h2 className="m-0 text-xl md:text-[22px] font-bold">Хичээлийн жилийн календарь</h2>
      <div className="text-sm text-[#6e5e8a] mb-2">{d.schoolYear || ""}</div>
      {d.terms.map((t) => (
        <div key={t.no} className="flex items-center gap-3 py-3 border-t border-[#efedf4]">
          <span className={`h-2.5 w-2.5 rounded-full ${t.current ? "bg-primary" : "bg-[#e5d8f5]"}`} />
          <span className={`flex-1 text-[15px] ${t.current ? "font-bold" : "font-semibold"}`}>{t.name}</span>
          <span className="text-sm text-[#6e5e8a]">{md(t.startDate)} – {md(t.endDate)}</span>
        </div>
      ))}
      {d.events.length > 0 && <div className="mt-4 text-xs font-bold tracking-[0.12em] uppercase text-[#6e5e8a]">Удахгүй</div>}
      {d.events.map((e) => (
        <div key={e.id} className="flex gap-4 py-3 border-t border-[#efedf4]">
          <span className="w-10 text-center shrink-0"><span className="block text-xl font-extrabold leading-none">{Number(e.startDate.slice(8, 10))}</span><span className="block text-[11px] text-[#6e5e8a]">{Number(e.startDate.slice(5, 7))}-р сар</span></span>
          <span><span className="block text-[15px] font-bold">{e.name}</span><span className="block text-xs text-[#6e5e8a]">{[e.type, e.endDate !== e.startDate ? `${md(e.startDate)} – ${md(e.endDate)}` : null, e.note].filter(Boolean).join(" · ")}</span></span>
        </div>
      ))}
    </section>
  );
}

export default function SchoolPage() {
  const { state } = useContext(AuthContext);
  const isStudent = state.studentInfo?.profile?.roleId == 4;
  const all = useKids(!isStudent);
  const kids = isStudent ? [{ id: "me", elem: false }] : all || [];
  const [params, setParams] = useSearchParams();
  const kid = kids.find((k) => String(k.id) === params.get("c")) || kids[0];
  const actions = ACTIONS.filter(([k]) => k === "leave" || kid?.elem);
  const [tab, setTab] = useState(params.get("tab") || "leave");
  const [d, setD] = useState(null);
  const load = () => kid && instance({ method: "get", url: `/student/school/${kid.id}` }).then((r) => setD(r.data)).catch(() => setD(false));
  useEffect(() => { setD(null); load(); }, [kid?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!isStudent && !all) return <div className="flex justify-center py-16"><Spin /></div>;
  if (!kid) return <div className="pt-7 max-w-[1180px] mx-auto"><section className="tj-card p-6 text-sm text-[#6e5e8a]">Хүүхэд бүртгэлгүй байна.</section></div>;
  return (
    <div className="pt-3.5 md:pt-7 pb-6 md:pb-14 max-w-[1180px] mx-auto flex flex-col gap-3.5 md:gap-5">
      <header>
        <h1 className="m-0 text-[28px] md:text-[34px] font-extrabold leading-tight">Сургууль</h1>
        <p className="m-0 text-sm md:text-[15px] text-[#6e5e8a]">{isStudent ? "Хүсэлт илгээх, хоолны цэс, хичээлийн жилийн календарь" : "Төлбөр, сургалт, Passion Program, хүсэлт, хоолны цэс, календарь"}</p>
      </header>
      {!isStudent && <KidTabs kids={kids} value={kid.id} onChange={(id) => setParams({ c: id })} />}
      {/* Эцэг эх: цэснээс энд шилжсэн — Төлбөр, Сургалт, Passion Program, Их сургуулийн өргөдөл (11-р анги) */}
      {!isStudent && (
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {[
            ["/paymentstatus", "Төлбөр", "Төлбөрийн мэдээлэл, төлөх", <FiCreditCard size={20} />],
            ["/learning", "Сургалт", "Эцэг эхэд зориулсан сургалт", <FiPlayCircle size={20} />],
            [`/passion?s=${kid.id}`, "Passion Program", `${kid.firstName || "Хүүхдийн"} дугуйлангийн сонголт`, <PassionIcon icon="basketball" size={28} />],
            ...(String(kid.grade) === "11" ? [["/college-prep/children", "Их сургуулийн өргөдөл", "Өргөдлийн явц · зөвлөхтэй уулзалт", <span className="font-extrabold">ИС</span>]] : []),
          ].map(([to, t, sub, icon]) => (
            <Link key={t} to={to} className="tj-card p-4 flex items-center gap-3 !text-[#1c1c1c] hover:bg-[#faf7ff]">
              <span className="h-11 w-11 rounded-xl bg-[#f3eeff] text-primary flex items-center justify-center shrink-0">{icon}</span>
              <span className="flex-1 min-w-0"><span className="block font-bold">{t}</span><span className="block text-xs text-[#6e5e8a] truncate">{sub}</span></span>
              <FiChevronRight className="text-primary shrink-0" />
            </Link>
          ))}
        </div>
      )}
      <section className="tj-card px-4 py-5 md:p-6 flex flex-col gap-5">
        <div className="grid gap-3 md:grid-cols-3">
          {actions.map(([k, t, sub, I, bg]) => (
            <button key={k} type="button" onClick={() => setTab(k)} aria-pressed={tab === k}
              className={`text-left rounded-2xl border p-4 flex items-center gap-3.5 ${tab === k ? "border-2 border-primary bg-[#faf7ff]" : "border-[#e9e8f0] bg-white hover:bg-[#faf7ff]"}`}>
              <span className="h-11 w-11 rounded-xl text-white flex items-center justify-center shrink-0" style={{ background: bg }}><I size={20} /></span>
              <span><span className="block text-base font-bold">{t}</span><span className="block text-[13px] text-[#6e5e8a]">{sub}</span></span>
            </button>
          ))}
        </div>
        {d === null ? <div className="flex justify-center py-6"><Spin /></div> : !d ? <p className="m-0 text-sm text-[#6e5e8a]">Мэдээлэл татаж чадсангүй</p> : (
          tab === "leave" || !kid.elem ? <LeaveForm kid={kid} d={d} reload={load} />
            : tab === "daycare" ? <DaycareCard studentId={kid.id} />
              : <FeedbackForm kid={kid} />
        )}
      </section>
      {isStudent && (
        <Link to="/booking" className="tj-card p-4 flex items-center gap-3 !text-[#1c1c1c] hover:bg-[#faf7ff]">
          <span className="h-11 w-11 rounded-xl bg-[#f3eeff] text-primary flex items-center justify-center shrink-0"><FiGrid size={20} /></span>
          <span className="flex-1"><span className="block font-bold">Танхим захиалга</span><span className="block text-xs text-[#6e5e8a]">Анги, танхим захиалах</span></span>
          <FiChevronRight className="text-primary" />
        </Link>
      )}
      {d && (
        <div className="flex flex-wrap gap-3.5 md:gap-5 items-start">
          <div className="flex-[1.5_1_440px] min-w-0"><Meals d={d} /></div>
          <div className="flex-[1_1_320px] min-w-0"><Calendar d={d} /></div>
        </div>
      )}
    </div>
  );
}
